import AppAlertComponent from '@/app/common/components/AppAlertComponent/AppAlertComponent'
import { Button } from '@/app/common/components/Button'
import { CircleLoader } from '@/app/common/components/CircleLoader'
import useIdentityVerification from '@/queries/identity_verification/useIdentityVerification'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths.ts'

type VariantType = "error" | "success" | "warning";

interface VerificationErrorMessageProps {
  errorMessage?: string;
  title?: string;
  variant?: VariantType;
}

function VerificationErrorMessage({ errorMessage, title, variant }: VerificationErrorMessageProps) {
  const { t: translate } = useTranslation()
  const { initiateIdentityVerification } = useIdentityVerification()

  const navigate = useNavigate();

  function handleRestartClick() {
    initiateIdentityVerification.mutate()
  }
  const selectedErrorMessage =
    errorMessage ?? translate('unexpected_error_occurred')

  const isLoading = initiateIdentityVerification.status === 'pending'
  return (
    <div className="h-full flex items-center justify-center">
      <AppAlertComponent
        title={title ? title : translate("error")}
        text={selectedErrorMessage}
        variant={variant ? variant : "error"}
      >
        <Button disabled={isLoading} onClick={handleRestartClick}>
          {isLoading ? (
            <span className="flex gap-1 items-center">
              <CircleLoader size="xsDisabledLoader" className="mr-1" />
              {translate('loading')}...
            </span>
          ) : (
            <>{translate('try_again')}</>
          )}
        </Button>

        <Button disabled={isLoading} onClick={
          () =>
            navigate(
              AppRoutePaths.family_application.identity_verification.manual_info
            )
        }>
          {isLoading ? (
            <span className="flex gap-1 items-center">
              <CircleLoader size="xsDisabledLoader" className="mr-1" />
              {translate('loading')}...
            </span>
          ) : (
            // <>{translate('try_again')}</>
            <>{translate('enter_manually')}</>
          )}
        </Button>
      </AppAlertComponent>
    </div>
  )
}

export default VerificationErrorMessage
